"use client"

import type { FunctionComponent, PropsWithChildren } from "react"

import { Button } from "@jobteaser/spark/components/Button"

import { Link } from "@/modules/routing/components/Link"

type CompanyLinkProps = PropsWithChildren<{
  url: string
}>

export const CompanyLink: FunctionComponent<CompanyLinkProps> = ({ children, url }) => (
  <Button
    renderComponent={Link}
    href={url}
    variant="primary"
    data-testid="jobad-DetailView-CompanySection-button-discover-company"
  >
    {children}
  </Button>
)
